import { ChangeDetectionStrategy, Component, input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'dr-flex-home-ui-empty-state',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'status',
    'aria-live': 'polite',
  },
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EmptyStateComponent {
  showPermissionStatus = input(false);

  title = input('FLEX_HOME.COMMON.NO_DATA');
  icon = input<string | null>(null);
}
